<template>
  <div v-if="stars" class="whs-hotel-stars">
    <div
      v-for="star in (parseInt(stars / 10, 10))"
      :key="star"
      :style="{fontSize: size + 'px'}"
      class="whs-hotel-star whs-icon"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'HotelStars',
  props: {
    size: {
      type: Number,
      default: 8
    },
    stars: Number
  }
};
</script>

<style scoped>
.whs-hotel-stars {
  display: inline-flex;
}
.whs-hotel-star:before {
  content: '\f005';
  color: var(--color-third);
  font-size: inherit;
  margin-right: 2px;
}
</style>